<div id="container">
  <!-- The loading indicator is displayed during bundle loading. Removed from DOM when ready. -->
  @if (!failed() && !ready()) {
    <div id="loading-container" role="status" aria-live="polite">
      <div id="loading">
        <mat-spinner id="loading-spinner" diameter="60" [attr.aria-label]="ariaLoadingLabel()" />
      </div>
    </div>
  }
  <!-- Error state for anything the element cannot come back from: a bundle or config that never
       loaded, and an element that loaded and then reported its own fatal error. -->
  @if (failed()) {
    <div id="error-container" role="alert" [attr.aria-label]="ariaErrorLabel()">
      <p>{{ failureMessage() }}</p>
    </div>
  }
  <!-- The host container for the custom element. Uses visibility instead of opacity
       to avoid creating a compositing layer that degrades WebGL rendering quality.
       Un-revealed on failure so a dead element is not left showing under the message. -->
  <div #elementHost class="content" [class.revealed]="ready() && !failed()" [style.pointerEvents]="interactionEnabled() ? 'auto' : 'none'">
    <!-- The custom element is appended here programmatically -->
  </div>
</div>
